export const examineeGroupData = [
  {
    id: 1,
    registrationDate: '12/06/2025 13:18:16',
    lastLogin: '12/06/2025 13:18:16',
    chatCount: 15,
    lastChat: '12/06/2025 13:46:50',
    memberId: '88709',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 2,
    registrationDate: '12/06/2025 13:05:05',
    lastLogin: '12/06/2025 13:05:05',
    chatCount: 8,
    lastChat: '12/06/2025 13:05:05',
    memberId: '88708',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: true
  },
  {
    id: 3,
    registrationDate: '12/06/2025 13:03:28',
    lastLogin: '12/06/2025 13:03:28',
    chatCount: 3,
    lastChat: '12/06/2025 13:03:28',
    memberId: '88707',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 4,
    registrationDate: '11/06/2025 14:20:10',
    lastLogin: '11/06/2025 14:20:10',
    chatCount: 22,
    lastChat: '11/06/2025 14:20:10',
    memberId: '88706',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 5,
    registrationDate: '11/06/2025 10:15:30',
    lastLogin: '11/06/2025 10:15:30',
    chatCount: 12,
    lastChat: '11/06/2025 16:45:20',
    memberId: '88705',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 6,
    registrationDate: '10/06/2025 09:30:45',
    lastLogin: '10/06/2025 09:30:45',
    chatCount: 5,
    lastChat: '10/06/2025 09:30:45',
    memberId: '88704',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 7,
    registrationDate: '10/06/2025 11:22:18',
    lastLogin: '10/06/2025 11:22:18',
    chatCount: 18,
    lastChat: '10/06/2025 15:10:25',
    memberId: '88703',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  },
  {
    id: 8,
    registrationDate: '09/06/2025 16:45:33',
    lastLogin: '09/06/2025 16:45:33',
    chatCount: 7,
    lastChat: '10/06/2025 08:30:15',
    memberId: '88702',
    citizenId: 'xxxxxxxxxxxxx',
    username: 'xxxxx',
    name: 'xxxxx xxxxx',
    company: 'xxxxx',
    campaign: 'xxxxx',
    isAdmin: false
  }
];